import { render, staticRenderFns } from "./AddressTab.vue?vue&type=template&id=219fdce4&scoped=true"
import script from "./AddressTab.vue?vue&type=script&lang=js"
export * from "./AddressTab.vue?vue&type=script&lang=js"
import style0 from "./AddressTab.vue?vue&type=style&index=0&id=219fdce4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219fdce4",
  null
  
)

export default component.exports